import { api } from '@/api/api-client.config.ts';
import { QuestionType } from '@/@types/api.types.ts';
import { useMutation } from '@tanstack/react-query';

interface UpdateQuestionProps {
  pickemId: number;
  question: QuestionType;
}

const updateQuestion = ({ pickemId, question }: UpdateQuestionProps) =>
  api.put(
    `/admin/pickem-questions/${pickemId}?question_id=${question.question_id}`,
    question
  );

export const useUpdateQuestionMutation = () => {
  return useMutation({
    mutationKey: ['updateQuestion'],
    mutationFn: updateQuestion,
  });
};
